import { useNavigate, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { useLocationState } from 'src/sensors/useLocationState.ts';

export const PageLegacy = ({ pathname }: { pathname: string }) => {
    const navigate = useNavigate();
    const { page, sensorLabel } = useParams();
    const [locationState, setLocationState] = useLocationState();

    useEffect(() => {
        const search = setLocationState({
            ...locationState,
            sensorLabel: sensorLabel !== undefined ? sensorLabel : locationState.sensorLabel,
            sensorsPage: page !== undefined ? page : locationState.sensorsPage,
        });
        navigate({
            pathname,
            search: search.toString(),
        });
    }, [sensorLabel, locationState, navigate, page, pathname, setLocationState]);

    return 'redirecting';
};
